var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('Heading'),_c('Main',[_c('p',[_vm._v("Use the contact button on the bottom right of the page. If the button is missing deactivate your privacy blockers")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }